import React from "react";
import "./Hr.css";
import { useNavigate } from 'react-router-dom';


function Hr(){

        const navigate = useNavigate();
  
    return(
        <div className="contents">
  <div className="container">
  {/* <!-- Row 1: Three Cards --> */}
  <div className="row justify-content-center g-4">
    <div className="col-md-4">
      <div className="cardid card border border-dark">

                      <div className="corner-circle"></div>

        <div className="card-body">
          <h5 className="card-title">
              <img src="socialmedia.png" alt="Logo"/>
         Recruitment & Talent Acquisition</h5>
          <p className="card-text">We help you find and hire skilled professionals who match your business needs. From job posting to screening, interviewing, and onboarding, we handle the entire recruitment process with speed and precision.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">

      <div className=" cardid card  border border-dark">
        <div className="corner-circle "></div>
        <div className="card-body">
         <h5 className="card-title">
        <img src="searchengine.png" alt="Logo"/>
             Payroll Management</h5>
          <p className="card-text">
         We manage accurate and timely payroll processing, including salary calculations, tax deductions, payslips, and compliance with labor laws. Our automated system ensures employees are paid correctly and on time, every time.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="Google.png" alt="Logo"/>
         Attendance & Leave Management</h5>
          <p className="card-text">Our HR services include advanced attendance tracking and leave management systems. Whether it’s biometric, manual, or app-based, we help you monitor employee availability and reduce manual errors in records.</p>
        </div>
      </div>
    </div>
  </div>

  <div className="row justify-content-center g-4 mt-3">
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="content.png" alt="Logo"/>
           Employee Records & HRMS Solutions</h5>
          <p className="card-text">We set up and maintain complete employee databases, including personal details, performance, appraisals, and document management. Our HRMS tools ensure easy access, data security, and operational efficiency.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="email.png" alt="Logo"/>
         Compliance & HR Policy Setups</h5>
          <p className="card-text"><br/>We help you stay compliant with labor laws and workplace regulations. From drafting employee handbooks to handling legal documentation and audit support, we ensure your HR practices are safe, legal, and standardized.</p>
        </div>
      </div>
    </div>
  </div>
</div>


<button type="button" className="exitbutton btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Move to Previous
</button>


<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Exit page</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      Are You Really want to Exit this page..
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary"  onClick={() => navigate("/allservices2")}>Yes</button>
      </div>
    </div>
  </div>
</div>


        </div>
    )

}
export default Hr;